// Site List Action Types
export const FETCH_SITE_LIST_REQUEST = 'FETCH_SITE_LIST_REQUEST';
export const FETCH_SITE_LIST_SUCCESS = 'FETCH_SITE_LIST_SUCCESS';
export const FETCH_SITE_LIST_FAILURE = 'FETCH_SITE_LIST_FAILURE';

// Practice Dropdown Action Types
export const FETCH_PRACTICE_DROPDOWN_REQUEST = 'FETCH_PRACTICE_DROPDOWN_REQUEST';
export const FETCH_PRACTICE_DROPDOWN_SUCCESS = 'FETCH_PRACTICE_DROPDOWN_SUCCESS';
export const FETCH_PRACTICE_DROPDOWN_FAILURE = 'FETCH_PRACTICE_DROPDOWN_FAILURE';

// Site Dropdown Action Types
export const FETCH_SITE_DROPDOWN_REQUEST = 'FETCH_SITE_DROPDOWN_REQUEST';
export const FETCH_SITE_DROPDOWN_SUCCESS = 'FETCH_SITE_DROPDOWN_SUCCESS';
export const FETCH_SITE_DROPDOWN_FAILURE = 'FETCH_SITE_DROPDOWN_FAILURE';

// Sub Practice Dropdown Action Types
export const FETCH_SUB_PRACTICE_DROPDOWN_REQUEST = 'FETCH_SUB_PRACTICE_DROPDOWN_REQUEST';
export const FETCH_SUB_PRACTICE_DROPDOWN_SUCCESS = 'FETCH_SUB_PRACTICE_DROPDOWN_SUCCESS';
export const FETCH_SUB_PRACTICE_DROPDOWN_FAILURE = 'FETCH_SUB_PRACTICE_DROPDOWN_FAILURE';

// Save Bulk Practice Site Action Types
export const SAVE_BULK_PRACTICE_SITE_REQUEST = 'SAVE_BULK_PRACTICE_SITE_REQUEST';
export const SAVE_BULK_PRACTICE_SITE_SUCCESS = 'SAVE_BULK_PRACTICE_SITE_SUCCESS';
export const SAVE_BULK_PRACTICE_SITE_FAILURE = 'SAVE_BULK_PRACTICE_SITE_FAILURE';
